module.exports = __webpack_public_path__ + "img/encuestas.48eea210.svg";